/*
    🔥 FUERZA DE CONTRASEÑA

    Cinco criterios, un punto cada uno. No es un análisis criptográfico:
    es una guía visual para que el usuario entienda por qué su clave
    es débil. La validación de verdad va en el backend.
*/

export const PASSWORD_RULES = [
    { id: 'length', label: 'Al menos 8 caracteres', test: (v) => v.length >= 8 },
    { id: 'lower', label: 'Una minúscula', test: (v) => /[a-z]/.test(v) },
    { id: 'upper', label: 'Una mayúscula', test: (v) => /[A-Z]/.test(v) },
    { id: 'number', label: 'Un número', test: (v) => /\d/.test(v) },
    { id: 'symbol', label: 'Un símbolo', test: (v) => /[^a-zA-Z0-9]/.test(v) },
];

export const PASSWORD_LEVELS = [
    { min: 0, id: 'empty', label: '', tone: 'neutral' },
    { min: 1, id: 'weak', label: 'Débil', tone: 'danger' },
    { min: 3, id: 'medium', label: 'Aceptable', tone: 'warning' },
    { min: 4, id: 'strong', label: 'Fuerte', tone: 'ok' },
    { min: 5, id: 'excellent', label: 'Excelente', tone: 'ok' },
];

export const onCheckPassword = (value = '') => {

    const RESULTS = PASSWORD_RULES.map((rule) => ({ ...rule, isOk: rule.test(value) }));

    const SCORE = RESULTS.filter((r) => r.isOk).length;

    const LEVEL = [...PASSWORD_LEVELS].reverse().find((l) => SCORE >= l.min) ?? PASSWORD_LEVELS[0];

    return { score: SCORE, total: PASSWORD_RULES.length, level: LEVEL, rules: RESULTS };
};
